import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadApplicantListSuccessful,
  loadApplicantListFailed,
  loadApplicantListBegin,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import {
  BACKEND_URL_V2, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY,
} from '../../../configs';
import { addFilterQuery } from '../../../utils/addFilterQueryWithCondition';

export default function* loadApplicantList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
      sort,
    } = payload;
    let pool = {
      limit,
      page,
      include: 'vehicles',
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool.filter = addFilterQuery(filter);
    }
    if (typeof sort === 'string' && sort.length) {
      pool = { ...pool, sort };
    }
    const url = `${BACKEND_URL_V2}/dict/applicants/search`;
    yield put(loadApplicantListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadApplicantListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadApplicantListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadApplicantListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
